import { CircularProgress } from "@material-ui/core";
import * as React from "react";
import { compose, pure, setDisplayName } from "recompose";
export var Render = function () { return React.createElement(CircularProgress, null); };
export function enhance() {
    return compose(pure, setDisplayName("Loading"));
}
export var Loading = enhance()(Render);
